const copyObject = (object) => {
    const newObject = {};
    for (const i in object)
        newObject[i] = object[i];
    return newObject;
}

export default copyObject;